import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Setting } from '../setting';
import { BaseService } from './base.services';

export type UserEmailStatus = 'new' | 'existing' | 'already-member' | 'disabled';

export interface UserEmailLookupResponse {
  data: { status: UserEmailStatus };
}

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(public setting: Setting, public baseService: BaseService<any>) {}

  getUsers(filter: any): Promise<any> {
    const params = new URLSearchParams();
    params.set('page', String(filter.pageSize || 1));
    params.set('limit', String(filter.rowsPerPage || 10));

    if (filter.search && filter.search.trim()) {
      params.set('search', filter.search.trim());
    }

    if (filter.enabled !== null && filter.enabled !== undefined) {
      params.set('enabled', String(filter.enabled));
    }

    const queryString = params.toString();
    const url = `${this.setting.Endpoint.Users}?${queryString}`;

    let promisse = new Promise((resolve, reject) => {
      this.baseService.get(url).subscribe({
        next: response => {
          resolve(response);
        },
        error: error => {
          reject(error);
        },
      });
    });

    return promisse;
  }

  getSelectedPermissions(roleId: number): Promise<any> {
    let promisse = new Promise((resolve, reject) => {
      this.baseService.get(`${this.setting.Endpoint.Roles}/${roleId}/access`).subscribe({
        next: response => {
          resolve(response);
        },
        error: error => {
          reject(error);
        },
      });
    });

    return promisse;
  }

  createUser(user: any): Promise<any> {
    let promisse = new Promise((resolve, reject) => {
      this.baseService.post(this.setting.Endpoint.UsersWithOrganization, user).subscribe({
        next: response => {
          resolve(response);
        },
        error: error => {
          reject(error);
        },
      });
    });

    return promisse;
  }

  lookupByEmail(email: string): Promise<UserEmailLookupResponse> {
    return firstValueFrom(
      this.baseService.post(`${this.setting.Endpoint.Users}/lookup-by-email`, { email }),
    );
  }

  linkExistingUser(email: string, roles_ids: number[]): Promise<any> {
    return firstValueFrom(
      this.baseService.post(`${this.setting.Endpoint.Users}/link-existing`, { email, roles_ids }),
    );
  }

  updateUser(id: number, user: any): Promise<any> {
    let promisse = new Promise((resolve, reject) => {
      this.baseService.put(`${this.setting.Endpoint.Users}/${id}`, user).subscribe({
        next: response => {
          resolve(response);
        },
        error: error => {
          reject(error);
        },
      });
    });

    return promisse;
  }

  getSalesRepresentatives(): Promise<any> {
    let promisse = new Promise((resolve, reject) => {
      this.baseService.get(`${this.setting.Endpoint.Users}/sales-rep`).subscribe({
        next: response => {
          resolve(response);
        },
        error: error => {
          reject(error);
        },
      });
    });

    return promisse;
  }

  disabledUser(userId: number): Promise<any> {
    let promisse = new Promise((resolve, reject) => {
      this.baseService
        .put(`${this.setting.Endpoint.Users}/${userId}/disable-from-organization`, { id: userId })
        .subscribe({
          next: response => {
            resolve(response);
          },
          error: error => {
            reject(error);
          },
        });
    });

    return promisse;
  }
  getUserOrganizations(): Promise<any> {
    let promesa = new Promise((resolve, reject) => {
      this.baseService.get(`${this.setting.Endpoint.Users}/organizations`).subscribe({
        next: response => {
          resolve(response);
        },
      });
    });

    return promesa;
  }

  exportUsersCsv(): Promise<any> {
    let promisse = new Promise((resolve, reject) => {
      this.baseService
        .get(`${this.setting.Endpoint.Users}/export/csv`, {
          responseType: 'text',
        })
        .subscribe({
          next: response => {
            resolve(response);
          },
          error: error => {
            reject(error);
          },
        });
    });

    return promisse;
  }
}
